import { render } from "./index.vue?vue&type=template&id=13d010b1&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=13d010b1&scoped=true&lang=less"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d010b1"]])

export default __exports__